<template>
  <v-card class="mb-3" style="border-radius: 10px;">
    <v-container>
      <v-layout row wrap>
        <v-flex xs12 sm7 py-0 pt-1>
        </v-flex>
        <v-flex xs12 sm5 py-0 text-xs-left text-sm-right pt-1>
          <div class="font-weight-thin">Registros: {{config.wire_accounts.length}}</div>
        </v-flex>
        <v-flex xs12 pa-0>
          <v-text-field v-model="wireAccountsFilter" class="search-filter" append-icon="search"></v-text-field>
        </v-flex>

        <wire-account :bank_accounts="config.bankAccounts" :record="wire_account" v-for="wire_account in config.wire_accounts" :key="wire_account.receiver.id" />

      </v-layout>
    </v-container>
    <v-card-actions>
      <v-layout column>
        <v-flex xs12>
          <v-btn v-if="showMoreBtn" block dark class="ma-0 btn-style" >
            EXIBIR MAIS
          </v-btn>
          <slot></slot>
        </v-flex>
      </v-layout>
    </v-card-actions>
  </v-card>
</template>
<script>
import WireAccount from "./WireAccountItem"

export default {
  name: 'WireAccountsList',
  components: { 'wire-account': WireAccount },
  props: {
    config: {
      type: Object
    }
  },
  data() {
    return {
      wireAccountsFilter: '',
      showMoreBtn: false
    }
  },
  computed: {
  }
}
</script>
<style>
  .search-filter .v-icon {
    color: #CCC!important;
  }
  .search-filter .v-text-field__slot input {
    color: #AAA!important;
  }
</style>



// WEBPACK FOOTER //
// src/WireAccountsList.vue